import script from "./NavigationBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationBar.vue?vue&type=script&setup=true&lang=ts"

import "./NavigationBar.vue?vue&type=style&index=0&id=53420180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53420180"]])

export default __exports__